export default __webpack_public_path__ + "static/media/i096vk.ec2d370d.webp";